// @flow
import type { Store } from 'effector'
import type { Location } from '../types'
import { domain } from './domain'
import { pushLocation } from './events'

const $locations: Store<Array<Location>> = domain.createStore([])

$locations.on(pushLocation, (state, location) => [...state, location])

export { $locations }
